import { ErrorMessageResponse } from '../../../../../app/core/models/data-response';

(function () {
    'use strict';

    angular.module('imApp').factory('multiProductCalcService', [
        '$ihttp',
        function ($ihttp) {
            let service = {
                getSetting: function (parms) {
                    return $ihttp.post({
                        method: 3860,
                        parameters: parms || {},
                    });
                },

                /**
                 *
                 * @param {GetSelectedVariantsParams} params
                 * @returns {Promise<ProdVariantsItem[]>} promise containing variants for the selected rows.
                 */
                getSelectedVariants: function (params) {
                    return $ihttp.post({ method: 3951, parameters: params });
                },

                /**
                 *
                 * @param {ProdVariantsItem} params
                 * @returns {Promise<ErrorMessageResponse>}
                 */
                calculateSelectedVariant: async function (params) {
                    return (await $ihttp.post({ method: 3952, parameters: params }))[0];
                },
            };

            return service;
        },
    ]);
})();

/**
 * @typedef {Object} GetSelectedVariantsParams
 * @property {string | number} datatask - the keyno of the grid.
 * @property {import ('../../../../../app/core/components/grid/grid.types').GridRow[]} isSelected - list of selected rows.
 * @property {Object} parameters - the parameters used in the grid.
 * @property {import ('../../../../../app/core/components/grid/grid.types').GridRow[]} rows - rows selected using native selection.
 */

/**
 * @typedef {Object} ProdVariantsItem
 * @property {string | number} prod_id
 * @property {string | number} prodchoice_keyno
 * @property {string | number} prodsize_keyno
 */
